import React, { useState, useEffect } from 'react';
import { Row, Col, Container, Card } from 'reactstrap';
import GeneralTile from '../general-tile/GeneralTile';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import { moduleMargins } from '../../Constants';


function ThreeSixColumn(props) {

  const renderContent = (content) => {
    return { __html: content };
  }
  //To get background based on device
  const getBackgroundImage = () => {
    if (isMobile && !isTablet) {
      return (props.imageMobile) ? props.imageMobile.path : '';
    }
    return (props.backgroundImage) ? props.backgroundImage.path : '';
  }

  useEffect(() => {
  //Logic to display same height for all the tiles in a row irrespective of content
    let getParentReference = document.getElementById("pdt-tiles-ctr-" + props.occurence);
    if (!isMobile || isTablet) {

      setTimeout(function () {
        var tiles = getParentReference.querySelectorAll(".three-six-desktop .tile-content");
        var firstRowTiles = [];
        
        tiles.forEach(tile => {
          tile.style.height = "auto";
        });

        if(tiles.length == 2){
          var firstRowLastIndex = 2;
        }
        else if (tiles.length !== 3) {
          var firstRowLastIndex = parseInt(tiles.length / 2);
        }
        else {
          var firstRowLastIndex = 3;
        }

        for (var i = 0; i < firstRowLastIndex; i++) {
          firstRowTiles.push(parseInt(tiles[i].clientHeight));
        }
        for (var i = 0; i < firstRowLastIndex; i++) {
          tiles[i].style.height = Math.max.apply(Math, firstRowTiles) + "px";
        }

        var secondRowTiles = [];
        for (var i = firstRowLastIndex; i < tiles.length; i++) {
          secondRowTiles.push(parseInt(tiles[i].clientHeight));
          tiles[i].style.height = Math.max.apply(Math, secondRowTiles) + "px";
        }
        for (var i = firstRowLastIndex; i < tiles.length; i++) {
          tiles[i].style.height = Math.max.apply(Math, secondRowTiles) + "px";
        }
      }, 3000);
    }

    if (isMobile && !isTablet) {
      setTimeout(function () {
        var tiles = getParentReference.querySelectorAll(".three-six-mobile .tile-content");
        if (tiles.length > 3) {
          var firstRowTiles = [];
          let firstRowLastIndex = tiles.length == 4 ? 0 : ((tiles.length == 5) ? 1 : 2);

          if(tiles.length == 6){
            var OptionalFirstRowTiles = [];
            for (var i = 0; i < 2; i++) {
              OptionalFirstRowTiles.push(parseInt(tiles[i].clientHeight));
            }
            for (var i = 0; i < 2; i++) {
              tiles[i].style.height = Math.max.apply(Math, OptionalFirstRowTiles) + "px";
            }
          }

          for (var i = firstRowLastIndex; i < firstRowLastIndex + 2; i++) {
            firstRowTiles.push(parseInt(tiles[i].clientHeight));
          }
          for (var i = firstRowLastIndex; i < firstRowLastIndex + 2; i++) {
            tiles[i].style.height = Math.max.apply(Math, firstRowTiles) + "px";
          }

          var secondRowTiles = [];
          for (var i = firstRowLastIndex + 2; i < tiles.length; i++) {
            secondRowTiles.push(parseInt(tiles[i].clientHeight));
          }
          for (var i = firstRowLastIndex + 2; i < tiles.length; i++) {
            tiles[i].style.height = Math.max.apply(Math, secondRowTiles) + "px";
          }
        }
      }, 2000);
    }

  })

  const getBackgroundColor = () => {
    if (isMobile && !isTablet) {
      return (props.mobileBackgroundColor) ? props.mobileBackgroundColor : '';
    }
    return (props.backgroundColor) ? props.backgroundColor : '';
  }

  let [marginDesktop, marginMobile] = moduleMargins(props.MarginDT, props.MarginMobile);
  const threeSixColumnProps = {
      marginClass : (!isMobile) ? marginDesktop : marginMobile,
  }

  return (
    <div id={"pdt-tiles-ctr-" + props.occurence} className={threeSixColumnProps.marginClass}>
      {(!isMobile || isTablet) &&
        <div style={{  //  added spacing module
          backgroundImage: "url(" + getBackgroundImage() + ")",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: getBackgroundColor(),
        }} >

          <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.moduleTitle)}></div>
          <Container className={ isMobileOnly ? 'mobilelandscapeContainer' : ''}>
            <Row>
              {props.desktoptiles.map((tile, i) => {             
              const isDoubleTile =
                props.desktoptiles.length === 2 ||
                props.desktoptiles.length === 4 ||
                (props.desktoptiles.length === 5 && (i === 0 || i === 1));
                return (
                  //<Col className={(props.desktoptiles.length == 2 || props.desktoptiles.length == 4 || (props.desktoptiles.length == 5 && (i == 0 || i == 1))) ? 'three-six-desktop col-6 mt-mb-30 desktop-double-tile' : 'three-six-desktop col-4 mt-mb-30 desktop-three-tile'} >
                    
                    <Col
                      lg={isDoubleTile ? "6" : "4"}
                      md="6"
                      sm="12"
                      className={`three-six-desktop mt-mb-30 ${
                        isDoubleTile ? "desktop-double-tile" : "desktop-three-tile"
                      }`}
                    >
                    <Card className="three_six_card">
                    <GeneralTile image={tile.image.path} id={'Product tile CTA ' + (i + 1)} title={tile.title} text={tile.text} alt={tile.altText} cta={tile.cta} ctaAlignment={tile.AlignmentCTA}></GeneralTile>
                    </Card>
                  </Col>
                );
              })
              }
            </Row>
          </Container>
        </div>
      }
      {isMobile && !isTablet && props.mobiletiles.length > 0 &&
        <div style={{ //  added spacing module
          backgroundImage: "url(" + getBackgroundImage() + ")",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundColor: getBackgroundColor(),
        }} >

          <div className="homepage-modules-title" dangerouslySetInnerHTML={renderContent(props.moduleTitle)}></div>
          <Container className={ isMobileOnly ? 'mobilelandscapeContainer' : ''}>
            <Row>
              {props.mobiletiles.map((tile, i) => {
                return (
                  <Col className={(props.desktoptiles.length == 2 || props.mobiletiles.length == 3 || (props.mobiletiles.length == 5 && (i == 0))) ? 'three-six-mobile col-12 mt-mb-30 mobile-single-tile' : ((props.mobiletiles.length == 4 && (i == 0 || i == 2)) || (props.mobiletiles.length == 5 && (i == 1 || i == 3)) || (props.mobiletiles.length == 6 && (i == 0 || i == 2 || i == 4))) ? 'three-six-mobile col-6 mt-mb-30 pr-2 mobile-double-tile' : 'three-six-mobile col-6 mt-mb-30 pl-2 mobile-double-tile'} >
                    <Card className="three_six_card">
                    <GeneralTile image={tile.image.path} id={'Product tile CTA ' + (i + 1)} title={tile.title} text={tile.text} alt={tile.altText} cta={tile.cta} ctaAlignment={tile.AlignmentCTA}></GeneralTile>
                    </Card>
                  </Col>
                );
              })
              }
            </Row>
          </Container>
        </div>
      }
    </div>
  );
}
export default ThreeSixColumn;

